let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cYKQ3")).then(() => parcelRequire('79qwo'));